<template>
  <div>
    <a-alert message="已提交的当前无法修改，如需修改/删除请进行申请退回操作。" banner />
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="项目信息录入">
        <item-information-form></item-information-form>
      </a-tab-pane>
      <a-tab-pane key="2" tab="中期检查录入" force-render>
        <interimNspection></interimNspection>
      </a-tab-pane>
      <a-tab-pane key="3" tab="绩效评价录入">
        <performance-evaluate></performance-evaluate>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import ItemInformationForm from './Item_Information_Form.vue'
import InterimNspection from './InterimNspection.vue'
import PerformanceEvaluate from './performanceEvaluate.vue'
export default {
  components: {
    ItemInformationForm,
    InterimNspection,
    PerformanceEvaluate
  },
  data() {
    return {}
  },
  methods: {
    // 选项卡切换
    callback(e) {
      console.log(e)
    },
  },
}
</script>

<style>
</style>